// extracted by mini-css-extract-plugin
export default {"footer":"footer_xsOUi","item":"item_TRFL3","link":"link_ExK8I"};